import ScreenDisplay from './ScreenDisplay.vue'
export default ScreenDisplay
